import { IS_IOS_AUDIO_ROUTED } from '#features/media-window/audioRouting';
import { useVoiceRoomOwner } from '#features/voice/components/VoiceRoomProvider';
import { VoiceDevicePicker } from '#features/voice/components/VoiceWidget/VoiceDevicePicker';

type RoomDeviceButtonProps = {
  /** В активной комнате настройки уже доступны рядом с микрофоном. */
  inThisRoom: boolean;
  size: '40px' | '44px';
};

/**
 * Предварительный выбор устройств в шапке комнаты, если платформа его поддерживает.
 *
 * Во время разговора настройки доступны рядом с микрофоном. На iOS предварительный выбор
 * не показываем: доступные выходы Safari проверяем в разговоре после разрешения микрофона,
 * а нативное переключение требует активной аудиосессии. На остальных платформах сохраняем
 * выбор устройства до входа.
 *
 * <p>Устройства принадлежат владельцу комнаты (провайдер на layout-роуте). Без него кнопки нет:
 * выбор, который ничего не переключает, хуже его отсутствия.
 */
export const RoomDeviceButton = ({ inThisRoom, size }: RoomDeviceButtonProps) => {
  const { hasOwner, listDevices, switchDevice } = useVoiceRoomOwner('RoomDeviceButton');

  if (!hasOwner || inThisRoom || IS_IOS_AUDIO_ROUTED) {
    return null;
  }

  return (
    <VoiceDevicePicker
      trigger="gear"
      height={size}
      active={false}
      listDevices={listDevices}
      onSelect={switchDevice}
    />
  );
};
